document.addEventListener('DOMContentLoaded', function () {
  var selectedOptions = [];

  window.addEventListener('angle3d:optionSelected', function (event) {
    var selected = event.detail;
    var label = selected.label || selected.name || selected.value || 'Selection';
    selectedOptions.push(label);

    var query = selectedOptions.map(function (opt, i) {
      return 'option' + (i + 1) + '=' + encodeURIComponent(opt);
    }).join('&');

    var contactBtn = document.getElementById('contactLink');
    if (contactBtn) {
      contactBtn.href = '/pages/contact?' + query;
    }
  });
});